import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { UnscheduleSurveyDialog } from 'modules/engagement_surveys/components/UnscheduleSurveyDialog'

type Data = {
  surveyId: string
}

export const UnscheduleSurveyActivity: ActivityComponent<Data> = ({ surveyId }) => {
  const { open, closeActivity } = useActivity()

  if (!open) return null

  return (
    <UnscheduleSurveyDialog
      surveyId={surveyId}
      onSuccess={closeActivity}
      onCancel={closeActivity}
    />
  )
}
